import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getIsMapServicesVisible } from 'shared/selectors/newbuildingMap';
import {
  selectInfrastructureFromBuilder,
  selectTransportAccessibility,
  selectTransportAccessibilitySource,
} from 'shared/selectors/transportAccessibility';

import { InfrastructureFromBuilderContainer } from './parts/InfrastructureFromBuilderContainer';
import { TransportAccessibilityContainer } from './parts/TransportAccessibilityContainer';
import { trackIndexTransportMoreClick, trackIndexTransportShow } from './tracking';
import { TransportAccessibilityRate } from '../../components/TransportAccessibilityRate';

export const TransportAccessibilityRateContainer: React.VFC = () => {
  const departmentLink = useSelector(selectTransportAccessibilitySource);
  const isMapServicesVisible = useSelector(getIsMapServicesVisible);
  const transportAccessibility = useSelector(selectTransportAccessibility);
  const infrastructure = useSelector(selectInfrastructureFromBuilder);
  const isAvailable = Boolean(transportAccessibility || infrastructure);

  // TODO: Проверка на isMapServicesVisible будет удалена при выпиле фича-флага в NB-1172.
  if (!isAvailable || isMapServicesVisible) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackIndexTransportShow} triggerOnce>
      <TransportAccessibilityRate
        departmentLink={departmentLink}
        onDepartmentLinkClick={trackIndexTransportMoreClick}
        transportAccessibility={
          transportAccessibility && <TransportAccessibilityContainer accessibility={transportAccessibility} />
        }
        infrastructureFromBuilder={
          infrastructure && <InfrastructureFromBuilderContainer infrastructure={infrastructure} />
        }
      />
    </ActionAfterViewObserver>
  );
};
